import { Component, OnInit, ViewChild } from "@angular/core";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";

import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";

import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { MotivoService } from "src/app/servicios/motivo.service";
import { TipoMotivoService } from "src/app/servicios/tipo-motivo.service";
import { TipoMotivoClasService } from "src/app/servicios/tipo-motivo-clas.service";

@Component({
  selector: "app-motivos",
  templateUrl: "./motivos.component.html",
  styleUrls: ["./motivos.component.css"],
})
export class MotivosComponent implements OnInit {
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtTrigger = new Subject();

  dtOptions: any = {
    pagingType: "full_numbers",
    scrollX: true,
    dom: "Bfrtip",
    buttons: [
      "colvis",
      {
        extend: "copyHtml5",

        exportOptions: {
          columns: ":visible",
        },
      },
      {
        extend: "excelHtml5",
        fileName: "CustomFileName" + ".xlsx",
        exportOptions: {
          columns: ":visible",
        },
        //CharSet: "utf8",
        exportData: { decodeEntities: true },
      },
    ],
  };

  motivos = [];
  haveData = false;
  loading = false;
  timeRunning = 0;
  isEdit = false;
  idDescEdit = "";

  motivoGroup: FormGroup;
  tiposMotivo = [];
  tiposMotivoClas = [];

  constructor(
    private serviceMotivo: MotivoService,
    private serviceTipoMotivo: TipoMotivoService,
    private serviceTipoMotivoClas: TipoMotivoClasService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar
  ) {
    this.motivoGroup = this.formBuilder.group({
      formCodigo: ["", [Validators.required, Validators.maxLength(50)]],
      formDescripcion: ["", [Validators.required, Validators.maxLength(50)]],
      formTipoMotivo: ["", Validators.required],
      formTipoMotivoClas: ["", Validators.required],
    });
    this.cargarSelect();
    this.loading = true;
    this.serviceMotivo.getMotivo(0).subscribe((result) => {
      this.motivos = result;
      console.log(this.motivos);
      this.haveData = true;
      this.loading = false;

      if (this.timeRunning == 0) {
        this.dtTrigger.next();
      } else {
        this.reRender();
      }
      this.timeRunning++;
    });
  }

  cargarSelect() {
    this.serviceTipoMotivo.getTipoMotivo(0).subscribe((result) => {
      this.tiposMotivo = result;
    });

    this.serviceTipoMotivoClas.getTipoMotivoClas(0).subscribe((result) => {
      this.tiposMotivoClas = result;
    });
  }

  ngOnInit() {}

  reRender() {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again

      this.dtTrigger.next();
    });
  }

  editar(item) {
    this.idDescEdit = item.id;
    this.motivoGroup.controls["formCodigo"].setValue(item.idExMotivo);
    this.motivoGroup.controls["formDescripcion"].setValue(item.valor);
    this.motivoGroup.controls["formTipoMotivo"].setValue(item.idTpoMotivo);
    this.motivoGroup.controls["formTipoMotivoClas"].setValue(
      item.idTpoMotivoCla
    );
    this.isEdit = true;
  }

  eliminar(item) {
    const tipoMotivo = item.id;
    const infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));
    const usuario = infoUsuario[0].IdUsuario;

    Swal.fire({
      title: "Eliminar Motivo?",
      text: "Esta seguro que desea eliminar este motivo!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Si, Eliminar!",
    }).then((result) => {
      if (result.value) {
        this.serviceMotivo
          .deleteMotivo(tipoMotivo, usuario)
          .subscribe((result) => {
            this.motivoGroup.reset();
            this.isEdit = false;
            this.refrescaBusqueda();
            Swal.fire("Eliminado!", "Registro Eliminado.", "success");
          });
      }
    });
  }

  cancelarEdit() {
    this.motivoGroup.reset();
    this.isEdit = false;
  }

  procesoMotivo() {
    //console.log(this.timeRunning);
    const infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));
    const usuarioConsulta = infoUsuario[0].IdUsuario;
    const codigoMotivo = this.motivoGroup.controls["formCodigo"].value;
    const descripcion = this.motivoGroup.controls["formDescripcion"].value;
    const tipoMotivo = this.motivoGroup.controls["formTipoMotivo"].value;
    const tipoMotivoClas = this.motivoGroup.controls["formTipoMotivoClas"]
      .value;
    const params = {
      idExtMotivo: codigoMotivo,
      descripcion: descripcion,
      tipoMotivo: tipoMotivo,
      tipoMotivoCla: tipoMotivoClas,
      usuario: usuarioConsulta,
    };
    if (this.isEdit) {
      //es por que estoy editando
      this.serviceMotivo
        .putMotivo(this.idDescEdit, params)
        .subscribe((result) => {
          this.refrescaBusqueda();
          this.motivoGroup.reset();
          this.isEdit = false;
          this.snackBar.open(
            "Tipo Motivo Actualizado",
            "Actualizar Tipo Motivo",
            {
              duration: 2000,
            }
          );
        });
    } //es por que estoy creando
    else {
      this.serviceMotivo.postMotivo(params).subscribe((result) => {
        this.motivoGroup.reset();
        this.refrescaBusqueda();
        this.snackBar.open("Tipo Motivo Creado", "Crear Tipo Motivo", {
          duration: 2000,
        });
      });
    }
  }

  refrescaBusqueda() {
    //externo 1 interno 2 externo

    this.loading = true;
    this.serviceMotivo.getMotivo(0).subscribe((result) => {
      this.motivos = result;
      //console.log(this.motivos);
      this.haveData = true;
      this.loading = false;

      if (this.timeRunning == 0) {
        this.dtTrigger.next();
      } else {
        this.reRender();
      }
      this.timeRunning++;
    });
  }
}
